import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { getCurrentLanguage, State } from '@ecap3/core'
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-empty-list',
    templateUrl: './empty-list.component.html',
    styleUrls: ['./empty-list.component.scss']
})
export class EmptyListComponent {
    lang$: Observable<string>;
    langSub: Subscription;
    public _unsubscribeAll: Subject<any> = new Subject();

    constructor(

        private translateService: TranslateService,
        private store: Store<State>,
    ) {
        this.lang$ = this.store.select(getCurrentLanguage);
        this._unsubscribeAll = new Subject();
    }

    public ngOnInit() {
        this.langSub = this.lang$.subscribe((lang) => {
            this.translateService.use(lang);
        });

    }
}
